import EduzzAppsToolbar from '@eduzz/apps-toolbar';
import { IUserToken } from 'interfaces/userToken';
import { ENV } from '../settings';

const toolbar = EduzzAppsToolbar({
  application: 'sun',
  show: true,
  env: ENV as 'production' | 'homolog' | 'development'
});

export async function setUser(user: Omit<IUserToken, 'betaFeatures'>) {
  const eduzzToolbar = await toolbar;

  eduzzToolbar.setUser({
    id: user?.id,
    email: user?.email,
    name: user?.name,
    belt: user?.belt,
    isSupport: user?.isSupport,
    supportId: user?.supportUserId,
    isClubeBlack: user?.isClubeBlack
  });

  eduzzToolbar.show();
}

export async function clearUser() {
  const eduzzToolbar = await toolbar;
  eduzzToolbar.hide();
}
